import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button, Grid } from "@material-ui/core";
// import InProcessCreateApplicationModal from "views/admin/components/Application/PersonalLoan/InProcessCreateApplicationModal";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { parseDateMDY } from "utils/Utils";
import { personalLoanColumns } from "assets/properties/properties";
import { statusBaseFilter } from "assets/properties/properties";
import { useNavigate } from "react-router-dom";
import { SearchTable } from "utils/Utils";

const PersonalLoan = ({classes, seletedBranchCode}) => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [loanLeadId, setLoanLeadId] = useState("");
  const [status, setStatus] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [filterStatus, setFilterStatus] = useState("INPROCESS");
  const [callInProgress, setCallInProgress] = useState(false);
  const [rawData, setRawData]=useState([])
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    getFeatureFlag();
  }, []);
  const getFeatureFlag = async () => {
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
    });
    GetData("INPROCESS");
  };

  useEffect(() => {
    if(filterStatus){
      GetData(filterStatus);
    }
  }, [filterStatus]);

  const GetData = async (status) => {
    const apiUrl = endpoint.SEARCH_PERSONAL_LOANS + status;
    setCallInProgress(true);
    const result = await apiHandler({
      url:
      apiUrl,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code || result?.data?.user_description) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      parseIndicatorData(result.data);
      setRawData(result?.data)
    }
  };
   const onSearchChange = (event) => {
      const filteredData = SearchTable(
        rawData,
        ["loanAccountNumber","name","customerId","mobileNumber"],
        event?.target?.value
      );
      parseIndicatorData(filteredData);
    };

  const parseIndicatorData = (data) => {
    let reportData = [];
    data = data?.sort((a, b) =>
      a?.id < b?.id ? 1 : -1
    );
    data &&
      data?.forEach((InProcessApplication, index) => {
        let row = {
          leadid: InProcessApplication.id,
          created: InProcessApplication.createdBy,
          accountNumber: InProcessApplication.loanAccountNumber,
          customerid: InProcessApplication.customerId,
          customerName: InProcessApplication.name,
          createdOn: parseDateMDY(InProcessApplication.createdOn),
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };

  const onClickUpdateData = async (
    loanId,
    status = "INPROCESS",
  ) => {
      setLoanLeadId(loanId);
      setStatus(status);
      navigate(`/personalLoanDetails/${loanId}`);
  };



  const handleSelectChange = (e) => {
    setFilterStatus(e)
  }
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label="Personal loan Details"
          selectInput
          selectData={statusBaseFilter}
          selectLabel="Filter By Status"
          handleSelectChange={handleSelectChange}
          selectValue={filterStatus}
          onSearchChange={onSearchChange}
          searchLabel="Search For Details"
          search
        />
      </Grid>      

      <Grid item xs={12} sm={12} md={12}>
        <ColumnGroupingTable columns={personalLoanColumns} rows={selectedTableData} onClickUpdateData={onClickUpdateData} flag="personalLoan"/>
      </Grid>
  
  {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
           {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

PersonalLoan.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
};

export default PersonalLoan;
